import { groq } from '#imports';

export function getQuery({ slug, isDraft = false, previewId } = {}) {
  const contentQuery = `{
    _type != 'recommendedArticle' && _type != 'authorOpinion' => @,
    _type == 'recommendedArticle' => {..., article-> {
       _type,
        slug,
        image,
        publishedAt,
        size,
        title,
        subtitle,
        titleColor,
        subtitleColor,
        shadowColor,
        titleColorFromColorPicker,
        subtitleColorFromColorPicker,
        shadowColorFromColorPicker,
        titleMarkColorFromColorPicker,
        isFullImage,
        backgroundColor[]{hex->},
        isArticleExternalSourceType,
        externalSource,
        crew[]{staff->, speciality->},
       }
      },
      _type == 'recommendedNewsItem' => {..., newsItem-> {
       _type,
        slug,
        publishedAt,
        title,
        titleColor,
        backgroundColor[]{hex->},
       }
      },
      _type == 'authorOpinion' => {..., author->}
    }`;

  if (isDraft) {
    return groq`*[_type == "article" && slug.current == "${slug}" && uuid == "${previewId}"] | order(_updatedAt desc)[0]{
      ...,
      'uuid': false,
      seoTitle,
      seoDescription,
      seoImageAlt,
      theme->,
      crew[]{staff->, speciality->},
      otherArticles[]->{
        slug,
        crew[]{staff->, speciality->},
        image,
        title,
        titleColor,
        subtitle,
        subtitleColor,
        titleColorFromColorPicker,
        subtitleColorFromColorPicker,
        isArticleExternalSourceType,
        shadowColorFromColorPicker,
        headerShadowColorFromColorPicker,
        titleMarkColorFromColorPicker,
        externalSource,
      },
      cards[]{..., content[]${contentQuery}},
      content[]${contentQuery}
    }`;
  }

  return groq`*[_type == "article" && slug.current == "${slug}" && !(_id in path('drafts.**'))][0]{
    ...,
    'uuid': false,
    seoTitle,
    seoDescription,
    seoImageAlt,
    theme->,
    crew[]{staff->, speciality->},
    otherArticles[]->{
      slug,
      crew[]{staff->, speciality->},
      image,
      title,
      titleColor,
      subtitle,
      subtitleColor,
      titleColorFromColorPicker,
      subtitleColorFromColorPicker,
      isArticleExternalSourceType,
      shadowColorFromColorPicker,
      headerShadowColorFromColorPicker,
      titleMarkColorFromColorPicker,
      externalSource,
    },
    cards[]{..., content[]${contentQuery}},
    content[]${contentQuery}
  }`;
}
